import React from 'react';
import './Fees.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';

const Fees = () => {
  return (
    <div className="page-wrapper">
      <Navbar />
      <div className="page-container light-theme">
        <div className="container">
          <header className="header">
            <h1>Fee Structure</h1>
            <p>Comprehensive fee details for all programs at RUK</p>
          </header>

        <div className="feeCategories">
          <div className="feeCard">
            <h3>Undergraduate Programs</h3>
            <div className="feeItem">
              <span>B.A. Programs</span>
              <span>₹25,000/year</span>
            </div>
            <div className="feeItem">
              <span>B.Sc. Programs</span>
              <span>₹30,000/year</span>
            </div>
            <div className="feeItem">
              <span>B.Com Programs</span>
              <span>₹28,000/year</span>
            </div>
          </div>

          <div className="feeCard">
            <h3>Postgraduate Programs</h3>
            <div className="feeItem">
              <span>M.A. Programs</span>
              <span>₹35,000/year</span>
            </div>
            <div className="feeItem">
              <span>M.Sc. Programs</span>
              <span>₹40,000/year</span>
            </div>
            <div className="feeItem">
              <span>M.Com Programs</span>
              <span>₹38,000/year</span>
            </div>
          </div>

          <div className="feeCard">
            <h3>Additional Fees</h3>
            <div className="feeItem">
              <span>Registration Fee</span>
              <span>₹2,000</span>
            </div>
            <div className="feeItem">
              <span>Library Fee</span>
              <span>₹1,500/year</span>
            </div>
            <div className="feeItem">
              <span>Laboratory Fee</span>
              <span>₹3,000/year</span>
            </div>
          </div>
        </div>

        <section className="paymentInfo">
          <h2>Payment Methods</h2>
          <div className="paymentMethods">
            <div className="paymentMethod">
              <h4>Online Payment</h4>
              <p>Pay securely through our online portal using Net Banking, Credit Card, or UPI</p>
            </div>
            <div className="paymentMethod">
              <h4>Bank Transfer</h4>
              <p>Direct bank transfer to university account (details provided after admission)</p>
            </div>
          </div>
        </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Fees;
